import { render } from "./EditLokasi.vue?vue&type=template&id=634220d1"
import script from "./EditLokasi.vue?vue&type=script&lang=js"
export * from "./EditLokasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__